module.exports = __webpack_public_path__ + "img/cross.8c0c9a3f.svg";